/*
 An example vuex module
 */


const state = {
  name: ''
}

export default {
  state
}